import { Device } from '@twilio/voice-sdk'
import { CallerType, CallStates } from 'api/models/Common/JyrneyEnums'
import * as React from 'react'

type Action =
  | { type: 'setIdentity'; payload: string }
  | { type: 'setIdToCall'; payload: string }
  | { type: 'setCallerType'; payload: CallerType }
  | { type: 'setDevice'; payload: Device }
  | { type: 'setCallState'; payload: CallStates }
  | { type: 'resetState'; payload: any }

type Dispatch = (action: Action) => void

interface TwilioState {
  identity: string | undefined
  id: string | undefined
  type: CallerType | undefined
  device: Device | undefined
  callState: CallStates | undefined
}

type PhoneProviderProps = { children: React.ReactNode }

const PhoneStateContext = React.createContext<TwilioState | undefined>(
  undefined,
)
const PhoneDispatchContext = React.createContext<Dispatch | undefined>(
  undefined,
)

const initalState = {
  identity: undefined,
  id: undefined,
  type: undefined,
  device: undefined,
  callState: CallStates.OFFLINE,
}

const phoneReducer = (state: TwilioState, action: Action) => {
  console.log('Action ', action.type)
  console.log('Payload ', action.payload)
  switch (action.type) {
    case 'setIdentity': {
      return { ...state, identity: action.payload }
    }
    case 'setIdToCall': {
      return { ...state, id: action.payload }
    }
    case 'setCallerType': {
      return { ...state, type: action.payload }
    }
    case 'setDevice': {
      return { ...state, device: action.payload }
    }
    case 'setCallState': {
      return { ...state, callState: action.payload }
    }
    case 'resetState': {
      return { ...initalState }
    }
    default: {
      throw new Error('Unhandled action type')
    }
  }
}

const PhoneContextProvider = ({ children }: PhoneProviderProps) => {
  const [state, dispatch] = React.useReducer(phoneReducer, initalState)
  return (
    <PhoneStateContext.Provider value={state}>
      <PhoneDispatchContext.Provider value={dispatch}>
        {children}
      </PhoneDispatchContext.Provider>
    </PhoneStateContext.Provider>
  )
}
const usePhoneState = () => {
  const context = React.useContext(PhoneStateContext)
  if (context === undefined) {
    throw new Error('usePhoneState must be used within a PhoneProvider')
  }
  return context
}
const usePhoneDispatch = () => {
  const context = React.useContext(PhoneDispatchContext)
  if (context === undefined) {
    throw new Error('usePhoneDispatch must be used within a PhoneProvider')
  }
  return context
}
export { PhoneContextProvider, usePhoneState, usePhoneDispatch }
